import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IdValuePair, LookupCriteria } from "@tylertech/tyler-api-types";
@Injectable()
export class ReadGroupService
{
    constructor(
        private readonly $apiService: ApiService
    ) { }

    lookup(value?: string): Promise<IdValuePair[]>
    {
        const lookupCriteria = <LookupCriteria>{ SearchText: value };
        return this.$apiService.sendAuth<LookupCriteria, IdValuePair[]>(
            "ILookupService/LookupReadGroups",
            lookupCriteria
        );
    }
}
